import { useEffect } from "react";

import { socket } from "../api/socket";

/**
 * Держит подписку на рынок, пока смонтирован компонент.
 *
 * Учёт держателей и выдержка перед отпиской живут в TradingSocket, поэтому
 * двойное монтирование в StrictMode здесь безвредно.
 *
 * Подписка идёт по condition_id и покрывает ОБА токена рынка сразу: хаб
 * маршрутизирует стакан по рынку, а не по токену.
 */
export function useMarketSubscription(conditionID: string | undefined): void {
  useEffect(() => {
    if (!conditionID) return;
    socket.retain(conditionID);
    return () => socket.release(conditionID);
  }, [conditionID]);
}
